import React from "react";
import { ExternalLink } from "lucide-react";

export default function CompuBrainSection({ text }) {
  if (!text) return null;
  const idx = text.indexOf("CompuBrain");
  const before = idx >= 0 ? text.slice(0, idx) : "";
  const after = idx >= 0 ? text.slice(idx + "CompuBrain".length) : text;
  return (
    <section
      className="mt-12 overflow-hidden rounded-[6px] border border-[var(--line)] bg-[var(--bg-panel)]"
      data-testid="compubrain-section"
      aria-label="About the parent company"
    >
      <div className="border-l-4 border-[var(--gov-blue)] p-5 sm:p-6">
        <div className="mb-1.5 flex items-center gap-2">
          <span className="text-[11px] font-bold uppercase tracking-widest text-[var(--gov-blue)]">
            Parent Company
          </span>
        </div>
        <p className="text-[15px] leading-relaxed text-[var(--ink-soft)]">
          {before}
          <a
            href="https://compubrain.com"
            target="_blank"
            rel="noopener noreferrer"
            className="font-bold text-[var(--navy)] underline decoration-[var(--gov-blue)] underline-offset-2 hover:text-[var(--gov-blue)]"
            data-testid="compubrain-link"
          >
            CompuBrain
          </a>
          {after}
        </p>
        <a
          href="https://compubrain.com"
          target="_blank"
          rel="noopener noreferrer"
          className="mt-3 inline-flex items-center gap-1.5 text-sm font-semibold text-[var(--gov-blue)] hover:underline"
          data-testid="compubrain-visit"
        >
          Learn more at compubrain.com <ExternalLink size={14} />
        </a>
      </div>
    </section>
  );
}
